"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const progress_1 = require("../../molecules/progress");
const icons_1 = require("../../atoms/icons");
const hooks_1 = require("../../shared/hooks");
const changeOrderInNutritionFacts_1 = __importDefault(require("./changeOrderInNutritionFacts"));
const fixSignOfNumber = (n) => {
    if (n > 0)
        return `+ ${n}`;
    else if (n === 0)
        return `${n}`;
    return `- ${Math.abs(n)}`;
};
const renderFactsProgress = ({ calorieBudget, calorieBudgetInfo }, unit, translation) => {
    var _a, _b, _c;
    const progress = [];
    const orderedNutritionFacts = (0, changeOrderInNutritionFacts_1.default)(calorieBudgetInfo);
    const hasBudget = !!calorieBudget;
    for (const fact in orderedNutritionFacts) {
        if (fact === "calories")
            continue;
        const percent = Math.round((_a = calorieBudgetInfo[fact]) === null || _a === void 0 ? void 0 : _a.progress);
        const diff = Math.round((_b = calorieBudgetInfo[fact]) === null || _b === void 0 ? void 0 : _b.difference);
        const factsValue = hasBudget
            ? `${translation[fact]} ${`(${Math.round(calorieBudget[fact])} ${unit})`}`
            : translation[fact];
        progress.push((0, jsx_runtime_1.jsx)(progress_1.ProgressHorizontal, { percent: percent, status: (_c = calorieBudgetInfo[fact]) === null || _c === void 0 ? void 0 : _c.status, left: factsValue, right: `${fixSignOfNumber(diff)} ${unit}` }, translation[fact]));
    }
    return progress;
};
const ProgressGroup = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { isMobile } = (0, hooks_1.useRWD)();
    const diff = (_b = (_a = props.day.calorieBudgetInfo) === null || _a === void 0 ? void 0 : _a.calories.difference) !== null && _b !== void 0 ? _b : 0;
    const hasBudget = !!props.day.calorieBudget;
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { "data-cy": "nutrient-day-progress", children: [(0, jsx_runtime_1.jsx)(progress_1.ProgressCircle, { percent: ((_c = props.day.calorieBudgetInfo) === null || _c === void 0 ? void 0 : _c.calories.progress) || 0, status: ((_d = props.day.calorieBudgetInfo) === null || _d === void 0 ? void 0 : _d.calories.status) || "OK", title: `${diff > 0 ? `+${diff}` : diff}`, subTitle: props.translations.progressBoxTranslations.circle.signature }, void 0), isMobile && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["fas", "pencil"], onClick: props.onLinkClick, color: "grey" }, void 0))] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [renderFactsProgress(props.day, props.unit, props.translations.progressBoxTranslations), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { "data-testid": "calories", children: hasBudget &&
                                    `${(_e = props.translations.webTranslations) === null || _e === void 0 ? void 0 : _e.calorieBudgetLabel}: ${props.sharedValues.caloriesValue} (${(_f = props.translations.webTranslations) === null || _f === void 0 ? void 0 : _f.trainingDayType})` }, void 0), (0, jsx_runtime_1.jsx)("h4", { onClick: props.onLinkClick, children: (_g = props.translations.webTranslations) === null || _g === void 0 ? void 0 : _g.rightBottomTextLabel }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
exports.ProgressGroup = ProgressGroup;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: flex;
  padding: ${({ theme }) => `${theme.spacings.s} ${theme.spacings.xl}`};

  & > div:first-of-type {
    width: 5rem;
    position: relative;
    margin: ${({ theme }) => `${theme.spacings.xxs} 1.875rem 0 0`};
  }

  & > div:last-of-type {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  & > div:last-of-type {
    flex: 1;
  }

  & > div:last-of-type > div {
    width: 50%;
  }

  & > div:last-of-type > div:nth-of-type(3),
  & > div:last-of-type > div:nth-of-type(4) {
    margin-top: ${({ theme }) => theme.spacings.xs};
  }

  & > div:last-of-type > div:nth-child(odd) {
    padding-right: ${({ theme }) => theme.spacings.s};
  }

  & > div:last-of-type > div:nth-child(even) {
    padding-left: ${({ theme }) => theme.spacings.s};
  }

  & > div:last-of-type > div:last-of-type {
    display: flex;
    justify-content: space-between;
    margin-top: ${({ theme }) => theme.spacings.xs};
    padding: 0;
    width: 100%;
  }

  & > div:last-of-type > div:last-of-type h4 {
    font-size: 0.875rem;
    font-weight: 500;
    margin: 0;
  }

  & > div:last-of-type > div:last-of-type h4:last-child {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacings.m};

    & > div:first-of-type {
      margin-right: 1rem;
      margin-top: 0;
      width: 8rem;

      & h4 {
        font-weight: 500;
      }
    }

    & > div:first-of-type > div:last-of-type {
      position: absolute;
      top: -${({ theme }) => theme.spacings.xs};
      right: -${({ theme }) => theme.spacings.xs};
    }

    & > div:last-of-type {
      flex-direction: column;
    }

    & > div:last-of-type > div:nth-child(odd),
    & > div:last-of-type > div:nth-child(even) {
      margin: 0;
      padding: 0;
      width: 100%;
    }

    & > div:last-of-type > div:not(:first-of-type) {
      margin-top: ${({ theme }) => theme.spacings.xs};
    }

    & > div:last-of-type > div:last-of-type {
      display: none;
    }
  }
`;
//# sourceMappingURL=ProgressGroup.js.map